<template>
    <section>
        <vue-topprogress color="#f7b400" ref="topProgress"></vue-topprogress>
        <Loading v-show="showLoader" class="loading"></Loading>
        <div v-if="noResult && !showLoader" class="text">
            <p>Spilleren blev ikke fundet</p>
            <button type="button" @click="$router.go(-1)">Gå tilbage</button>
        </div>
        <div v-else-if="noPunishments() && !showLoader" class="text">
            <p>Spilleren har ingen straffe</p>
            <button type="button" @click="$router.go(-1)">Gå tilbage</button>
        </div>
        <div v-else-if="!showLoader">
            <div class="row">
                <TableCounter :bans="bans" :kicks="kicks" :mutes="mutes"/>
                <TableFilter v-on:change-filter="filterChange($event)"/>
            </div>
            <DiscordTable :punishments="punishments" :with-type="true"/>
            <div class="pagination">
                <Pagination :current-page="this.$route.params.page" :max-page="maxPage"/>
            </div>
        </div>
    </section>
</template>

<script>
    import Pagination from '../../components/Pagination'
    import DiscordTable from '../../components/tables/DiscordTable'
    import TableFilter from '../../components/tables/TableFilter'
    import TableCounter from '../../components/tables/TableCounter'
    import Progress from 'vue-top-progress'
    import Loading from '../../components/Loading'

    export default {
        components: {
            Pagination,
            DiscordTable,
            TableFilter,
            Progress,
            TableCounter,
            Loading
        },
        data() {
            return {
                punishments: [],
                rawPunishments: [],
                maxPage: 1,
                bans: 0,
                kicks: 0,
                mutes: 0,
                noResult: false,
                showLoader: true
            }
        },
        created() {
            this.updatePunishments();
        },
        mounted() {
            if (this.$refs.topProgress !== undefined) {
                this.$refs.topProgress.start();
            }
        },
        computed: {
            title() {
                let name = this.type;
                return name.substring(0,1).toUpperCase() + name.substring(1);
            },
            titled() {
                switch (this.type) {
                    case "kicks":
                        return "Kicked";
                    case "bans":
                        return "Banned";
                    case "mutes":
                        return "Muted";
                    case "names":
                        return "Banned";
                    default:
                        return "Straffet";
                }
            },
            type() {
                return this.$utils.getPageType(this.$route.name).type;
            },
            category() {
                return this.$utils.getPageType(this.$route.name).category;
            },
        },
        methods: {
            filterChange(enabled) {
                this.punishments = this.rawPunishments.filter(f => enabled.includes(f.type.toLowerCase()));
            },
            updatePunishments() {
                Promise.all([this.$api.getPunishmentOnUser(this.category, this.$route.params.id, this.$route.params.page), this.$api.getCountsOnUser(this.category, this.$route.params.id)]).then(values => {
                    if (values[0].punishments === null) {
                        this.noResult = true;
                    } else {
                        this.punishments = values[0].punishments;
                        this.rawPunishments = values[0].punishments;
                        this.maxPage = values[0].maxPage;
                        this.bans = values[1].bans;
                        this.mutes = values[1].mutes;
                        this.kicks = values[1].kicks;
                    }
                    this.showLoader = false;
                    this.$refs.topProgress.done()
                }).catch(err => {
                    console.log(err);
                    if (this.$refs.topProgress !== undefined) {
                        this.$refs.topProgress.fail();
                    }
                });
            },
            noPunishments() {
                return this.rawPunishments.length === 0;
            }
        },
    }
</script>

<style lang="scss" scoped>
    section {
        padding: 0 20px;
        min-height: 250px;

        .loading {
            margin-top: 50px;
        }

        .text {
            padding: 150px 0;
            text-align: center;

            p {
                margin-bottom: 50px;
                text-shadow: 2px 2px 7px #111;
                font-size: 20px;
                letter-spacing: .5px;
            }

            button {
                color: #6c757d;
                cursor: pointer;
                border: 0;
                background-color: #262a2d;
                font-weight: 400;
                padding: .375rem .75rem;
                font-size: 1rem;
                line-height: 1.5;
                border-radius: .25rem;
                transition: ease .2s;

                &:hover {
                    background-color: #2e3235;
                    color: #fff;
                }
            }
        }
        .row{
            display: flex;
            justify-content: space-between;
        }

        .pagination {
            display: flex;
            margin-top: 2rem;
            justify-content: center;
        }

        table {
            width: 100%;
            font-size: 16.5px;
            margin-bottom: 0;
            text-align: center;
            border-collapse: collapse;

            thead {
                background: #262a2d;

                th {
                    vertical-align: middle;
                    overflow-wrap: break-word;
                    padding: .75rem;
                    font-weight: bold;

                    &.small {
                        width: 15%;
                    }
                }
            }

            tbody {
                tr {
                    background-color: rgba(0, 0, 0, .05);

                    &:nth-of-type(odd) {
                        background-color: hsla(0, 0%, 100%, .05);
                    }

                    td {
                        vertical-align: middle;
                        overflow-wrap: break-word;
                        padding: .75rem;

                        a {
                            color: #fff;
                            text-decoration: none;
                        }
                    }

                    .user {
                        img {
                            border-radius: 2px;
                            display: block;
                            margin: 0 auto;
                            vertical-align: middle;
                            padding-bottom: 5px;
                        }
                    }

                    .expired {
                        padding-top: 5px;
                        font-style: italic;
                        font-size: 15px;
                        color: #878e94;
                        max-width: 100%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
</style>
